import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
export function Contact() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formState);
    alert('Thank you for your message. We will get back to you shortly.');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="py-24 bg-slate-50" data-id="element-47">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-50">
            Send Us a Message <span className="text-accent" data-id="element-51">Directly</span>
          </h2>
          <p className="text-lg text-slate-600" data-id="element-52">
            Have a project in mind? Fill out the form below and our team will
            get back to you within 24 hours. Or email us directly at{' '}
            <a href="mailto:info@AlUniversalApps.com" className="text-accent hover:underline font-medium" data-id="element-53">
              info@AlUniversalApps.com
            </a>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-white rounded-3xl p-8 shadow-xl border border-slate-100" data-id="element-54">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-55">
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-56">
              <div data-id="element-57">
                <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-58">
                  Full Name
                </label>
                <input type="text" id="name" name="name" required value={formState.name} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all bg-slate-50 focus:bg-white" placeholder="John Doe" data-id="element-59" />
              </div>
              <div data-id="element-60">
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-61">
                  Email Address
                </label>
                <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all bg-slate-50 focus:bg-white" placeholder="john@company.com" data-id="element-62" />
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-63">
              <div data-id="element-64">
                <label htmlFor="company" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-65">
                  Company
                </label>
                <input type="text" id="company" name="company" value={formState.company} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all bg-slate-50 focus:bg-white" placeholder="Your Company" data-id="element-66" />
              </div>
              <div data-id="element-67">
                <label htmlFor="service" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-68">
                  Service of Interest
                </label>
                <select id="service" name="service" value={formState.service} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all bg-slate-50 focus:bg-white" data-id="element-69">
                  <option value="" data-id="element-70">Select a service...</option>
                  <option value="ai" data-id="element-71">AI & Machine Learning</option>
                  <option value="mobile" data-id="element-72">Mobile App Development</option>

                  <option value="other" data-id="element-73">Other / General Inquiry</option>
                </select>
              </div>
            </div>

            <div data-id="element-74">
              <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-75">
                Message
              </label>
              <textarea id="message" name="message" required rows={5} value={formState.message} onChange={handleChange} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all bg-slate-50 focus:bg-white resize-none" placeholder="Tell us about your project or needs..." data-id="element-76"></textarea>
            </div>

            <button type="submit" className="w-full py-4 bg-primary text-white font-semibold rounded-xl hover:bg-primary-light transition-colors flex items-center justify-center gap-2 group" data-id="element-77">
              Send Message
              <Send className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-78" />
            </button>
          </form>
        </motion.div>
      </div>
    </section>;
}